import IndexPage from "./pages/index";
// import Landing from "./pages/Landing";
import GeneratorPage from "./pages/generator";
import PricingPage from "./pages/pricing";
import DashboardPage from "./pages/dashboard";
import ItemPage from "./pages/item";
import AuthPage from "./pages/auth";
import SettingsPage from "./pages/settings";
import LegalPage from "./pages/legal";
import AboutPage from "./pages/about";
import PurchasePage from "./pages/purchase";
import FirebaseActionPage from "./pages/firebase-action";
import NotFoundPage from "./pages/404";
import GalleryPage from "./pages/gallery";
import ContactPage from "./pages/contact";
import CreditPage from "./pages/credit";
import AiNudePage from "./pages/ai-nude-generator";
import ChatPage from "./pages/chat";
import ThankyouPage from "./pages/thankyou";
import FailurePage from "./pages/failure";
import PaySuccessPage from "./pages/paysuccess";
import PayFailurePage from "./pages/payfailure";
// import HentaiAi from "./pages/hentai-ai";
// import NsfwAiApps from "./pages/nfsw-ai-apps";
// import TalkieAI from "./pages/talkie-ai";
// import NsfwCharacterAi from "./pages/nsfw-character-ai";

// Define routes with metadata for sitemap generation
const routes = [
  {
    path: "/",
    exact: true,
    component: IndexPage,
    sitemap: { priority: "1.0", changefreq: "weekly" },
  },
  {
    path: "/ai-girlfriend/:slug",
    component: ChatPage,
    sitemap: { priority: "0.7", changefreq: "weekly", dynamic: true },
  },
  // {
  //   path: "/nsfw-ai-apps",
  //   exact: true,
  //   component: NsfwAiApps,
  //   sitemap: { priority: "0.8", changefreq: "weekly" },
  // },
  // {
  //   path: "/talkie-ai",
  //   exact: true,
  //   component: TalkieAI,
  //   sitemap: { priority: "0.8", changefreq: "weekly" },
  // },
  // {
  //   path: "/nsfw-character-ai",
  //   exact: true,
  //   component: NsfwCharacterAi,
  //   sitemap: { priority: "0.8", changefreq: "weekly" },
  // },
  // {
  //   path: "/ai-hentai",
  //   exact: true,
  //   component: HentaiAi,
  //   sitemap: { priority: "0.8", changefreq: "weekly" },
  // },
  {
    path: "/create",
    exact: true,
    component: GeneratorPage,
    sitemap: { priority: "0.8", changefreq: "weekly" },
  },
  {
    path: "/success",
    exact: true,
    component: ThankyouPage,
    sitemap: {
      priority: "0.5",
      changefreq: "monthly",
      includeInSitemap: false,
    },
  },
  {
    path: "/paysuccess",
    exact: true,
    component: PaySuccessPage,
    sitemap: {
      priority: "0.5",
      changefreq: "monthly",
      includeInSitemap: false,
    },
  },
  {
    path: "/failure",
    exact: true,
    component: FailurePage,
    sitemap: {
      priority: "0.5",
      changefreq: "monthly",
      includeInSitemap: false,
    },
  },
  {
    path: "/payfailure",
    exact: true,
    component: PayFailurePage,
    sitemap: {
      priority: "0.5",
      changefreq: "monthly",
      includeInSitemap: false,
    },
  },
  {
    path: "/gallery",
    exact: true,
    component: GalleryPage,
    sitemap: { priority: "0.7", changefreq: "weekly" },
  },
  {
    path: "/images/:id",
    component: ItemPage,
    sitemap: { priority: "0.6", changefreq: "weekly", dynamic: true },
  },
  {
    path: "/pricing",
    exact: true,
    component: PricingPage,
    sitemap: { priority: "0.8", changefreq: "monthly" },
  },
  {
    path: "/credit",
    exact: true,
    component: CreditPage,
    sitemap: { priority: "0.7", changefreq: "monthly" },
  },
  {
    path: "/ai-nude",
    exact: true,
    component: AiNudePage,
    sitemap: { priority: "0.8", changefreq: "weekly" },
  },
  {
    path: "/chat",
    exact: true,
    component: ChatPage,
    sitemap: { priority: "0.8", changefreq: "weekly" },
  },
  {
    path: "/about",
    exact: true,
    component: AboutPage,
    sitemap: { priority: "0.6", changefreq: "monthly" },
  },
  {
    path: "/contact",
    exact: true,
    component: ContactPage,
    sitemap: { priority: "0.6", changefreq: "monthly" },
  },
  {
    path: "/dashboard",
    exact: true,
    component: DashboardPage,
    sitemap: {
      priority: "0.7",
      changefreq: "weekly",
      requiresAuth: true,
      includeInSitemap: false,
    },
  },
  {
    path: "/auth/:type",
    component: AuthPage,
    sitemap: {
      priority: "0.5",
      changefreq: "monthly",
      includeInSitemap: false,
    },
  },
  {
    path: "/settings/:section",
    component: SettingsPage,
    sitemap: {
      priority: "0.5",
      changefreq: "monthly",
      requiresAuth: true,
      includeInSitemap: false,
    },
  },
  {
    path: "/legal/:section",
    component: LegalPage,
    sitemap: { priority: "0.4", changefreq: "yearly" },
  },
  {
    path: "/purchase/:plan",
    component: PurchasePage,
    sitemap: {
      priority: "0.7",
      changefreq: "monthly",
      includeInSitemap: false,
    },
  },
  {
    path: "/firebase-action",
    exact: true,
    component: FirebaseActionPage,
    sitemap: { priority: "0.5", changefreq: "yearly", includeInSitemap: false },
  },
  {
    path: "*",
    component: NotFoundPage,
    sitemap: { includeInSitemap: false },
  },
];

export default routes;

// Helper function to get public routes for sitemap
export const getPublicRoutes = () => {
  return routes.filter((route) => {
    // Skip routes marked to not be included in sitemap or requiring auth
    if (
      route.sitemap?.includeInSitemap === false ||
      route.sitemap?.requiresAuth
    ) {
      return false;
    }

    // Skip dynamic routes for basic sitemap (these would need special handling)
    if (route.sitemap?.dynamic) {
      return false;
    }

    return true;
  });
};

// Helper function to get all static URL paths for sitemap
export const getStaticPaths = () => {
  return getPublicRoutes().map((route) => route.path);
};
